export default __webpack_public_path__ + "static/media/lights_001.14d48b4c.jpg";